import { AsyncActionState } from '@telstra-connect/standard-actions/async-action';
import { ITicketsState } from '../state';
import { IncidentTableColumns } from '../state/single-ui/incident-filters';

export const initialState: ITicketsState = {
    incidents: {
        items: [],
        incidentsCounts: { open: 0, closed: 0 },
        status: AsyncActionState.NotStarted
    },

    summary: {
        data: {
            openTickets: 0,
            customerPendingTickets: 0,
            allTickets: 0,
            numberOfTicketsByPriority: {
                P1: '00',
                P2: '00',
                P3: '00',
                P4: '00'
            },
            totalPrioritizedTickets: 0
        },
        status: AsyncActionState.NotStarted
    },

    createTicket: {
        status: AsyncActionState.NotStarted
    },

    ticketDetails: {
        status: AsyncActionState.NotStarted
    },

    ticketAttachments: {
        status: AsyncActionState.NotStarted
    },

    deleteAttachments: {
        status: AsyncActionState.NotStarted
    },

    ticketActivities: {
        items: [],
        pagination: {
            totalCount: 0,
            pageSize: 0,
            stateId: ''
        },
        status: AsyncActionState.NotStarted
    },

    serviceTypes: {
        items: [],
        status: AsyncActionState.NotStarted
    },

    ticketComment: {
        status: AsyncActionState.NotStarted
    },

    patchTicket: {
        status: AsyncActionState.NotStarted
    },

    escalateIncident: {
        status: AsyncActionState.NotStarted
    },

    ticketStatus: { status: '', lastUpdatedAt: '' },

    featureFlags: {
        status: AsyncActionState.NotStarted,
        flags: {
            majorIncidents: false,
            autoFillCategoryNonSIIam: false,
            escalateIncident: false,
            isCWPCustomer: false,
            isSIIAMCustomer: false,
            merge: false,
            useInternationalMerge: false
        }
    },

    customerReference: null,

    Ccv: {
        status: AsyncActionState.NotStarted,
        data: {
            defaultCompany: null,
            totalCompaniesCount: 0
        }
    },

    fileUploads: {
        data: [],
        status: AsyncActionState.NotStarted
    },
    attachmentRequest: {
        status: AsyncActionState.NotStarted
    },

    customServiceIdPatchRequest: {
        status: AsyncActionState.NotStarted
    },

    attachmentsList: [],

    incidentSession: sessionStorage.getItem('IM:attachments') || 'false',

    summaryCustomServiceId: {
        customServiceId: ''
    },

    serviceLocationSummary: {
        locations: [],
        status: AsyncActionState.NotStarted
    },

    closeIncident: {
        status: AsyncActionState.NotStarted
    },

    requestedClosure: false,

    majorIncidents: {
        data: [],
        status: AsyncActionState.NotStarted
    },

    selectedMajorIncident: '',

    covid19IncidentFlag: false,

    userProfileDetails: {
        status: AsyncActionState.NotStarted,
        data: null
    },

    filterOptionsRequest: {
        status: AsyncActionState.NotStarted,
        filterOptions: {
            status: [],
            priority: [],
            assignedTo: [],
            incidentType: [],
            location: false,
            actualResolutionDate: false,
            estimatedResolutionDate: false,
            createdBy: [],
        }
    },

    filteredLocations: {
        locations: [],
        status: AsyncActionState.NotStarted
    },
    globalFilterOptionsRequest: {
        status: AsyncActionState.NotStarted,
        filterOptions: {
            status: [],
            priority: [],
            assignedTo: [],
            incidentType: [],
            location: false,
            actualResolutionDate: false,
            estimatedResolutionDate: false,
            createdBy: [],
        }
    },
    globalFilteredLocations: {
        locations: [],
        status: AsyncActionState.NotStarted
    },

    mdmTenancyIDsRequest: {
        tenancyIds: [],
        status: AsyncActionState.NotStarted
    },

    mergeTestIdRequest: {
        mergeTestId: '',
        plannedOutageId: '',
        status: AsyncActionState.NotStarted
    },

    mergeTestResultsRequest: {
        mergeTestResults: {
            mergeResponse: {
                serviceId: '',
                status: '',
                result: []
            },
            outageResponse: []
        },
        status: AsyncActionState.NotStarted
    },

    mergeTestHistoryRequest: {
        history: {
            mergeTestHistory: {
                createdOn: '',
                mergeTestId: '',
                inputSuite: '',
            },
            plannedOutageHistory: {
                createdOn: '',
                mergeTestId: '',
                inputSuite: '',
            },
        },
        status: AsyncActionState.NotStarted
    },

    mergeTestServiceIdValidationRequest: {
        status: AsyncActionState.NotStarted,
        mergeTestServiceIdValidation: {
            isValid: false
        }
    },

    dynamicFormRequest: {
        status: AsyncActionState.NotStarted,
        formConfig: []
    },

    intMergeTestRequest: {
        results: [],
        status: AsyncActionState.NotStarted
    },

    ipVoiceMergeTestIdRequest: {
        mergeTestId: '',
        status: AsyncActionState.NotStarted
    },

    ipVoiceMergeTestResultsRequest: {
        mergeTestResults: {
            serviceId: '',
            status: '',
            productName: '',
        },
        status: AsyncActionState.NotStarted
    },

    guestServiceAddressRequest: {
        data: {
            simplifiedAddresses: [],
        },
        status: AsyncActionState.NotStarted
    },

    guestServiceAddressContactRequest: {
        data: {
            simplifiedAddresses: [],
        },
        status: AsyncActionState.NotStarted
    },

    guestServiceIdRequest: {
        data: {
            services: [],
            pagination: {
                pageSize: 0,
                totalCount: 0
            }
        },
        status: AsyncActionState.NotStarted
    },

    guestIncidentsRequest: {
        incidents: [],
        status: AsyncActionState.NotStarted
    },

    guestIncidentsSummaryRequest: {
        data: {
            activeIncidents: 0,
            maxAllowedGuestIncidents: 0
        },
        status: AsyncActionState.NotStarted
    },

    createGuestIncidentRequest: {
        data: {
            sniNumber: ''
        },
        status: AsyncActionState.NotStarted
    },

    guestIncidentDetailsRequest: {
        data: {
            incidentId: '',
            status: '',
            customerReference: '',
            description: '',
            createdOn: '',
            estimatedResolutionDate: '',
            actualResolutionDate: '',
            issueDetails: {},
        },
        status: AsyncActionState.NotStarted
    },

    raisedForRequest: {
        data: {
            requestedUsers: []
        },
        status: AsyncActionState.NotStarted
    },
    downloadStatus: {
        status: AsyncActionState.NotStarted
    },

    globalLocationServiceIDsRequest: {
        data: {
            services: [],
            pagination: {
                pageSize: 0,
                totalCount: 0
            }
        },
        status: AsyncActionState.NotStarted
    },

    patchGlobalIncidentRequest: {
        status: AsyncActionState.NotStarted
    },

    trackIncidentsList: {
        status: AsyncActionState.NotStarted,
        sessionId: null,
        tableConfig: {
            currentPage: 1,
            pageSize: 25
        },
        sortParam: {
            sortBy: '',
            sortOrder: 'none'
        },
        searchText: '',
        incidentList: null,
        filters: [], // to be implemented
        selectedFilters: null, // to be implemented
        selectedColumns: Object.keys(IncidentTableColumns) as Array<keyof typeof IncidentTableColumns>
    },
    trackIncidentsExport: {
        status: AsyncActionState.NotStarted
    }
};

